import { sortBy, completeISODateString, resolveObjectKey } from '$lib/utils'

export const regexFilter = (needle, haystack) => {
    return [
        needle,
        (f) => f.filter((i) => new RegExp(`${needle}`).test(i[haystack])),
    ]
}

export const multiKeyFilter = (needle, haystack) => {
    return [
        typeof needle === 'string',
        (f) =>
            f.filter((i) => {
                return haystack.some((x) =>
                    new RegExp(
                        `${needle.replace(/[^\x00-\x7F]+/g, '.')}`,
                        'i'
                    ).test(String(resolveObjectKey(x, i)) || '')
                )
            }),
    ]
}

export const timestampFilter = (needle, haystack) => {
    let [st = 0, ed = Number.POSITIVE_INFINITY] = needle
    return [
        Boolean(st || ed),
        (f) =>
            st && ed
                ? f.filter((i) => i[haystack] >= st && i[haystack] <= ed)
                : st
                  ? f.filter((i) => i[haystack] >= st)
                  : f.filter((i) => i[haystack] <= ed),
    ]
}

export const isoDateFilterTimestamp = (needle, haystack) => {
    let [st, ed] = needle
    st = st ? new Date(st).valueOf() / 1000 || null : null
    ed = ed ? new Date(ed).valueOf() / 1000 + 86400 || null : null
    return timestampFilter([st, ed], haystack)
}

export const isoDateFilter = (needle, haystack, gmt = 0) => {
    let [st, ed] = needle
    st = st ? new Date(completeISODateString(st, gmt)) : null
    if (ed) {
        ed = new Date(completeISODateString(ed, gmt))
    }
    let assertFilter = ed ? ed >= st : st
    if (assertFilter) {
        if (ed) {
            ed.setDate(ed.getDate() + 1)
            ed.setMilliseconds(-1)
        }
    }
    return [
        assertFilter, // Assert
        (f) =>
            st && ed // Filter
                ? f.filter(
                      (i) =>
                          new Date(i[haystack]).getTime() >= st.getTime() &&
                          new Date(i[haystack]).getTime() <= ed.getTime()
                  ) // "Desde - Hasta"
                : st
                  ? f.filter(
                        (i) => new Date(i[haystack]).getTime() >= st.getTime()
                    ) // Solo "Desde"
                  : f.filter(
                        (i) => new Date(i[haystack]).getTime() <= ed.getTime()
                    ), // Solo "Hasta"
    ]
}

export const rangeFilter = (needle, haystack) => {
    let [st, ed] = needle.map((x) => Number(x))
    return [
        st <= ed,
        (f) => f.filter((i) => st <= i[haystack] && ed >= i[haystack]),
    ]
}

export const idFilter = (needle, haystack) => {
    return [needle, (f) => f.filter((i) => needle === i[haystack])]
}

export const buildFilterCompilator = (base = undefined) => {
    return (filters, sort = []) => {
        let pipelines = base ? [base] : []
        for (let filterSet of filters) {
            let [assert, filter] = filterSet
            if (assert) {
                pipelines.push(filter)
            }
        }
        pipelines.push((f) => f.toArray())
        if (sort.length > 0) {
            pipelines.push((f) =>
                f.then((r) => {
                    return sortBy(r, sort)
                })
            )
        }
        return (f) =>
            pipelines.reduce((a, b) => {
                return b(a)
            }, f)
    }
}
